import { observable } from "@chorda/core";
import { Cell, Row, Table } from "chorda-bulma";
import { COUNTRIES } from "../data";
const countries = observable(COUNTRIES, (v) => v.name);
const screenNulls = (v) => v == null ? '-' : String(v);
export default () => {
    return Table({
        headerRows: [
            Row({
                cells: [
                    Cell({ text: 'Name' }),
                    Cell({ text: 'Capital' }),
                    Cell({ text: 'Region' }),
                    Cell({ text: 'Area' }),
                    Cell({ text: 'Population' }),
                    Cell({ text: 'GINI' }),
                ]
            })
        ],
        defaultRow: Row({
            cells: [
                Cell({ data$: ({ data }) => data.name }),
                Cell({ data$: ({ data }) => data.capital }),
                Cell({ data$: ({ data }) => data.region }),
                Cell({ data$: ({ data }) => data.area }),
                Cell({ data$: ({ data }) => data.population }),
                Cell({ data$: ({ data }) => data.gini, format: screenNulls }),
            ]
        }),
        data$: () => countries
    });
};
